module.exports = __webpack_public_path__ + "static/media/OBP.dcb5a65f.png";